import { EntryModel } from "@app/data/engine.ts";
import { formatUsd } from "@app/helpers/money-helper.ts";
import { formatDate } from "@app/helpers/time-helper.ts";
import { Checkbox } from "@mui/material";
import { createColumnHelper } from "bi-lib";

interface Props {
    onSelect: (id: string) => void;
    selectedItems: string[];
    rowCount: number;
}

const columnHelper = createColumnHelper<EntryModel>();
export const uploadReceiptTableDefinition = ({ onSelect, selectedItems, rowCount }: Props) => [
    columnHelper.display({
        id: "actions",
        header: "",
        cell: (item) => (
            <Checkbox
                checked={selectedItems.includes(item.row.original.entryId!)}
                onChange={() => onSelect(item.row.original.entryId!)}
            />
        ),
        footer: () => `${rowCount} Rows`,
    }),
    columnHelper.accessor((x) => x.itemDate, {
        id: "itemDate",
        header: "Date",
        cell: (item) => formatDate(item.getValue()),
    }),
    columnHelper.accessor((x) => x.categoryDescription, { id: "categoryDescription", header: "Category" }),
    columnHelper.accessor((x) => x.subcategory, { id: "subcategory", header: "Subcategory" }),
    columnHelper.accessor((x) => x.staffName, { id: "staffName", header: "Staff" }),
    columnHelper.accessor((x) => x.billingAmount, {
        id: "billingAmount",
        header: "Billing Amount",
        cell: (item) => formatUsd(item.getValue()),
        alignment: "right",
    }),
    columnHelper.accessor((x) => x.assignDescription, { id: "assignDescription", header: "Assignment" }),
    columnHelper.accessor((x) => x.description, { id: "description", header: "Description" }),
];
